<template>
  <div class="building-owner-form d-flex flex-column">
    <b-row class="mb-3">
      <h3>{{ "Modifier l'invité" }}</h3>
    </b-row>
    <b-row class="mb-5">
      <b-col cols="6">
        <label>{{ "Nom et prénom" }}</label>
        <ValidationProvider
          ref="vee-b-fullname"
          v-slot="{ errors, classes }"
          :name="'nom'"
          rules="required"
        >
          <b-input :value="meetingGuest.fullname" @input="updateMeetingGuest('fullname', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>

      <b-col cols="6">
        <label>{{ "Email" }}</label>
        <ValidationProvider
          ref="vee-b-email"
          v-slot="{ errors, classes }"
          :name="'email'"
          rules="required|email"
        >
          <b-input :value="meetingGuest.email" @input="updateMeetingGuest('email', $event)" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mt-5 mb-2 justify-content-end">
      <b-col cols="auto">
        <b-button class="button btn-red" @click="cancel">
          <font-awesome-icon class="agv-button-icon" icon="times-circle" />
          <span>{{ $t("general.cancel") }}</span>
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button :disabled="isLoadingSave" class="button btn-blue" @click="UPDATE_MEETING_GUEST">
          <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
          <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
          <span>{{ $t("general.enregistrer") }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import MeetingGuestMW from "@/middlewares/MeetingGuest";
import { validate } from "vee-validate";
export default {
  props: {
    existentMeetingGuest: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      meetingGuest: null,
      isLoadingSave: false,
    };
  },
  created() {
    this.meetingGuest = this.existentMeetingGuest;
  },
  methods: {
    updateMeetingGuest(key, value) {
      this.meetingGuest[key] = value;
    },
    cancel() {
      this.$emit("cancel");
    },
    async validateStep() {
      var valid = true;
      let values = [
        {
          key: "fullname",
          rules: "required",
        },
        {
          key: "email",
          rules: "required",
        },
      ];
      for (const value of values) {
        await validate(this.meetingGuest[value.key], value.rules, {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["vee-b-" + value.key].validate();
          }
        });
      }
      return valid;
    },
    async UPDATE_MEETING_GUEST() {
      if (!(await this.validateStep())) {
        return;
      }
      this.isLoadingSave = true;
      MeetingGuestMW.PUT(this.meetingGuest)
        .then(meetingGuest => {
          this.meetingGuest = meetingGuest;
          this.isLoadingSave = false;
          this.cancel();
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
  },
};
</script>
